export const checkPlural = (data: any[]) => (data.length === 1 ? '' : 's');
